import splitName from './splitName.js'

function prepareKoNamePost() {
	let postString = ''
	if (!window.koStore && !window.indiaStore) return false
	if (
		document.querySelector('#nameBillingDisplay') &&
		document.querySelector('#nameBillingDisplay').value
	) {
		const name = splitName(document.querySelector('#nameBillingDisplay').value)

		if (document.getElementById('sameAsShipping').checked === true) {
			postString += `&firstNameBilling=${name.firstName}&lastNameBilling=${name.lastName}&firstName=${name.firstName}&lastName=${name.lastName}`
		} else {
			postString += `&firstNameBilling=${name.firstName}&lastNameBilling=${name.lastName}`
		}
	}

	if (
		document.querySelector('#nameDisplay') &&
		document.querySelector('#nameDisplay').value
	) {
		const name = splitName(document.querySelector('#nameDisplay').value)
		postString += `&firstName=${name.firstName}&lastName=${name.lastName}`
	}

	return postString
}

export default prepareKoNamePost


